import { post } from "./axiosConfig";
export default {
    postRequest: function (payload = {}) {
        return post(payload);
    },
}